// extracted by mini-css-extract-plugin
export default {"container":"fca-z","productName":"gca-z","price":"hca-z","dimensions":"ica-z"};